<template>
    <div v-if="showMissionList" class="codelab-mission-list mission-area">
        <div class="category-list">
            <ul v-if="categoryList">
                <li v-if="!mission.keys.length" class="unlock-more-mission category-item" @click="unlockMoreMission">
                    <template v-if="!isPublic()">
                        <svg-icon href="#codelab-icon-unlock" :width="20" :height="20"></svg-icon>
                    </template>
                    <span class="label">
                        {{ isPublic() ? $t("go_to_buy_kebbi") : $t("unlock_more_mission")}}
                    </span>
                </li>
            </ul>
        </div>
        <div class="category-mission-list">
            <el-scrollbar class="mission-list-scrollbar" ref="scrollBar">
                <div v-for="category in currentCategory" :key="category.missionCategoryId">
                    <div class="category-description"  >
                        <h3>{{category.title}}</h3>
                        <p :class="shit$(`mxw:780px;`)">{{category.description}}</p>
                    </div>
                    <div class="mission-list" v-if="category.list">
                        <ul>
                            <li v-for="mission in category.list.payload" :key="mission.missionId">
                                <mission-item @select="onSelectMission" :mission="mission"></mission-item>
                            </li>
                        </ul>
                    </div>
                </div>
            </el-scrollbar>
        </div>
        <!-- <missionProcess /> -->
    </div>
</template>
<script>
import { mapState } from "vuex";
import missionItem from "@/code-lab/component/mission/mission-item.vue";

import {
  store as exchangeStore,
} from "@/code-lab/component/exchange/observable.js";
import missionMix from "@/code-lab/component/mission/mission-mix.js";
export default {
  name: "mission-list",
  components: {
    missionItem,
  },
  mixins: [missionMix],
  data() {
    return {
      hasTaskRouteVersion: ["public", "family"],
      arrTemp: []
    };
  },
  computed: {
    mission: () => exchangeStore.mission,
    ...mapState("missionList", {
      categoryList(state) {
        return state.categoryList[state.updateCurrentId];
      },
      currentCategoryId: "currentCategoryId",
      currentMissionId: "currentMissionId",
      resizeTimer: "resizeTimer",
      updateCurrentId: "updateCurrentId"
      
    }),
    ...mapState({
      showMissionList: "showMissionList",
      currentVersion: "currentVersion",
      
      langCode: "langCode",
      currentMission: "currentMission",
      getMissionListCmd: state =>
        state.currentVersion === "public"
          ? "get_public_mission_list"
          : "get_mission_list",
      getMissionCategoryCmd: state =>
        state.currentVersion === "public"
          ? "get_public_mission_category_list"
          : "get_mission_category_list",
      getMissionCmd: state =>
        state.currentVersion === "public" ? "get_public_mission" : "get_mission"
    }),
    currentCategory() {
      if (this.categoryList) {
        if (this.currentCategoryId) {
          return (
            this.categoryList.payload.filter(
              item => item.missionCategoryId === this.currentCategoryId
            ) || []
          );
        } else {
          return this.categoryList.payload;
        }
      } else {
        return [];
      }
    }
  },
  watch: {
    currentCategoryId() {
      this.updateScrollBar();
      this.scroll2Top();
    },
  },
  created() {
    
    
    
    this.getMissionCategoryList().then(async res => {
      const updateCurrentId = this.util$.getRandomId$("getMission");
      this.$store.commit("missionList/updateCurrentId", updateCurrentId);
      let { payload, query } = res;
      const pros = payload.map(category =>
        this.getMissionList(category.missionCategoryId)
      );
      if (
        typeof this.updateCurrentId === "string" &&
        updateCurrentId !== this.updateCurrentId
      )
        return;
      await Promise.all(pros).then(res => {
        res.forEach((missionList, index) => {
          let { query: missionQuery, payload: missionPayload } = missionList;
          this.lockCard(missionPayload);
          this.$set(payload[index], "list", {
            query: missionQuery,
            payload: missionPayload
          });
        });
      });
      if (this.categoryList) {
        const obj = {};
        obj[this.updateCurrentId] = {
          ...this.categoryList,
          payload: this.categoryList.payload.concat(this.categoryList.payload),
          query
        };
        
        
        
        this.c({ categoryList: obj });
      } else {
        const obj = {};
        obj[this.updateCurrentId] = { payload, query };
        this.c({ categoryList: obj });
        
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    isPublic() {
      return this.currentVersion === "public";
    },
    lockCard(list) {
      if (
        this.currentVersion === "family" &&
        !exchangeStore.mission.keys.length
      ) {
        this.arrTemp = [...this.arrTemp, ...list];
        this.arrTemp.slice(5).forEach(item => (item.lock$ = true));
      }
    },
    addMissionKey(query) {
      
      
      Object.assign(query, { key: exchangeStore.mission.keys.slice(-1)[0] });
      
    },
    c(payload, type = "missionList/update") {
      this.$store.commit(type, payload);
    },
    onCategoryClick(categoryId) {
      this.c({ currentCategoryId: categoryId });
      
    },
    unlockMoreMission() {
      this.isPublic()
        ? window.open(this.util$.getNuwaWebsite())
        : this.unlockMoreMission$();
    },
    onSelectMission(mission) {
      if (!mission.lock$) {
        mission.nextMission = this.getNextMission(mission);
        
        this.c({ currentMissionId: mission.missionId });
        this.$store.commit("SET_CURRENT_MISSION", mission);
        if (this.hasTaskRouteVersion.includes(this.currentVersion)) {
          this.$store.commit("SHOW_MISSION_LIST", false);
          this.$router.push({ path: "/" });
        }
        setTimeout(() => {
          this.$store.commit("SELECTEDMENUERIGHT", null);
        }, 200);
      } else {
        console.log(this.$t( "code-lab/component/mission/mission-list.vue_2" ));
        this.unlockMoreMission$();
      }
    },
    updateScrollBar() {
      this.$nextTick(() => {
        if (this.$refs.scrollBar) {
          this.$refs.scrollBar.update();
        }
      });
    },
    scroll2Top() {
      this.$nextTick(() => {
        if (
          this.$refs.scrollBar &&
          this.$refs.scrollBar.$el.querySelector(".el-scrollbar__wrap")
        ) {
          this.$refs.scrollBar.$el.querySelector(
            ".el-scrollbar__wrap"
          ).scrollTop = 0;
        }
      });
    },
    nextMission() {
      let currentMission = this.currentMission;
      if (currentMission && currentMission.nextMission) {
        let nextMission = currentMission.nextMission;
        this.$store.commit("SET_CURRENT_MISSION", null);

        this.$nextTick(() => {
          this.onSelectMission(nextMission);
        });
      }
    },
    getNextMission(mission) {
      let { section, missionCategoryId } = mission;
      let currentCategory = this.getMissionCategoryById(missionCategoryId);
      let nextMission =
        mission.nextMission ||
        currentCategory.list.payload.find(item => item.section === section + 1);
      if (!nextMission) {
        let nextCategory = this.getNextMissionCategoryById(missionCategoryId);
        if (nextCategory) {
          nextMission =
            nextCategory.list.payload.find(item => item.section === 1) ||
            nextCategory.list.payload[0] ||
            null;
        }
      }
      return nextMission;
    },
    updateMissionData(mission) {
      let { missionId, missionCategoryId } = mission;
      if (this.categoryList && this.categoryList.payload) {
        let category = this.categoryList.payload.find(
          item => item.missionCategoryId === missionCategoryId
        );
        if (category) {
          let missionIndex = category.list.payload.findIndex(
            item => item.missionId === missionId
          );
          if (missionIndex >= 0) {
            category.list.payload.splice(missionIndex, 1, mission);
          }
        }
      }
    },
    getMissionCategoryById(missionCategoryId) {
      if (this.categoryList) {
        return this.categoryList.payload.find(
          item => item.missionCategoryId === missionCategoryId
        );
      } else {
        return null;
      }
    },
    getNextMissionCategoryById(missionCategoryId) {
      if (this.categoryList) {
        let currentCategoryIndex = this.categoryList.payload.findIndex(
          item => item.missionCategoryId === missionCategoryId
        );
        if (currentCategoryIndex >= 0) {
          return this.categoryList.payload[currentCategoryIndex + 1] || null;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    getMissionCategoryList(query) {
      return new Promise(resolve => {
        let langCode = this.langCode || "zh-CN";
        if (!query) {
          query = {
            sort: "name",
            limit: 999,
            page: 1,
            langCode
          };
          this.addMissionKey(query);
        } else {
          let { limit, currentPage } = query;
          query = {
            sort: "name",
            limit,
            page: currentPage + 1,
            langCode
          };
        }
        const { clientId, customerId } = this.b$.tool.store
          ? this.b$.tool.store
          : {};
        const ver = "v1";
        const cmd = this.getMissionCategoryCmd;
        this.b$.send(
          "tool",
          {
            cmd,
            data: {
              ver,
              clientId,
              customerId,
              query
            }
          },
          res => {
            resolve(res.data);
          }
        );
      });
    },
    getMissionList(missionCategoryId = this.currentCategoryId, query = null) {
      return new Promise((resolve, reject) => {
        let langCode = this.langCode || "zh-CN";
        if (!missionCategoryId) {
          reject();
          return;
        }
        if (query && query.currentPage >= query.totalPages) {
          reject();
          return;
        }
        if (!query) {
          query = {
            sort: "name",
            limit: 999,
            langCode,
            page: 1
          };
          this.addMissionKey(query);
        } else {
          let { limit, currentPage, sort, langCode } = query;
          query = {
            sort,
            limit,
            langCode,
            page: currentPage + 1
          };
        }
        const { clientId, customerId } = this.b$.tool.store
          ? this.b$.tool.store
          : {};
        const ver = "v1";
        this.b$.send(
          "tool",
          {
            cmd: this.getMissionListCmd,
            data: {
              ver,
              clientId,
              customerId,
              missionCategoryId,
              query
            }
          },
          res => {
            resolve(res.data);
          }
        );
      });
    },
    onResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        
        this.c({ resizeTimer: null });
      }
      this.c({
        resizeTimer: setTimeout(() => {
          this.updateScrollBar();
        }, 300)
      });
    },
    clearMssionData$() {
      this.c({ categoryListCp: this.categoryList });
      this.c({ categoryList: {} });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.clearMssionData$();
  }
  
  
};
</script>
<style lang="scss">
.codelab-mission-list {
  padding: 25px;
  display: flex;
  flex-direction: column;
  .category-list {
    width: 100%;
    padding: 15px;
    flex: 0 0 auto;
    position: relative;
    margin-top: -14px;
    @mixin tag-style {
      display: inline-block;
      line-height: 30px;
      padding: 0 16px;
      border-radius: 16px;
      white-space: nowrap;
      font-size: 0;
      color: #ffffff;
      border: 1px solid transparent;
      cursor: pointer;
      svg {
        fill: #ffffff;
      }
    }
    ul {
      width: 100%;
      height: 32px;
      padding-right: 140px;
      overflow: hidden;
      font-size: 0;
      position: relative;
      .category-item {
        @include tag-style;
        margin-right: 24px;
        margin-top: 14px;
        background: transparent;
        border-color: #979797;
        &:hover {
          color: #ffffff;
          background: $--codelab-primary-blue-3;
          border-color: transparent;
        }
        &.active,
        &:active {
          color: $--codelab-primary-black-1;
          background: $--codelab-primary-blue-1;
          border-color: transparent;
        }
        .label {
          font-size: 16px;
          vertical-align: middle;
        }
      }
      .unlock-more-mission {
        
        background: $--codelab-primary-blue-3;
        border-color: transparent;
        position: absolute;
        right: 0;
        top: -14px;
        &:hover,
        &:active {
          color: #ffffff;
          background: $--codelab-primary-blue-1;
        }
      }
    }
  }
  .category-mission-list {
    width: 100%;
    overflow: hidden;
    flex: 1 1 auto;
    .mission-list-scrollbar {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      .category-description {
        width: 100%;
        color: #c8c8c8;
        padding: 24px 15px;
        h3 {
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 1.5px;
        }
        p {
          margin-top: 8px;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.9px;
        }
      }
      .mission-list {
        ul {
          width: 100%;
          overflow: hidden;
          li {
            width: 250px;
            height: 290px;
            float: left;
            margin: 15px;
          }
        }
      }
    }
  }
}
.mission-area {
  position: fixed;
  width: calc(100% - 64px);
  height: calc(100% - 60px);
  left: 64px;
  top: 60px;
  background: $--codelab-primary-black-1;
  z-index: 100;
  &.hide {
    width: 0;
    height: 0;
    overflow: hidden;
    padding: 0;
  }
}
</style>